import Storage from "@utils/storage";
import { REMEMBER_ME_EXPIRE_TIME, USER_INFO_KEY } from "@constants/common";
import { UserData } from "@/types/login-type";

export default () => {
  const saveUserInfoToLocal = (data: UserData) => {
    Storage.cache.set(USER_INFO_KEY, data, REMEMBER_ME_EXPIRE_TIME);
  };

  const getUserInfoFromLocal = () => {
    return (Storage.cache.get(USER_INFO_KEY) || {}) as UserData;
  };

  const clearLocalUserInfo = () => {
    Storage.cache.clearAll();
  };

  const getAuthorization = () => {
    const userInfo = Storage.cache.get(USER_INFO_KEY) as UserData;
    if (userInfo?.token) {
      return "Bearer " + userInfo.token;
    }
    return "";
  };

  return {
    saveUserInfoToLocal,
    getUserInfoFromLocal,
    clearLocalUserInfo,
    getAuthorization,
  };
};
